import List from "@mui/material/List";
import React from "react";
import styles from "./EntityList.module.css";
import { EntityItem, EntityType } from "../../common-types/Entity";
import EntityListItem from "../EntityListItem/EntityListItem";

interface EntityListProps {
  grids: 1 | 2 | 3;
  entities: EntityItem[];
  onClick?: (id: string, type: EntityType) => void;
}

const EntityList: React.FC<EntityListProps> = ({
  grids,
  entities,
  onClick,
}: EntityListProps) => {
  return (
    <List
      dense={true}
      className={`${styles["container"]} ${styles[`container-${grids}`]}`}
    >
      {entities.map((entity) => (
        <EntityListItem onClick={onClick} {...entity} key={entity.id} />
      ))}
    </List>
  );
};

export default EntityList;
